
// This file is generated by the maven plugin com.axley.js-remodel.  Do not edit!!!


export class GenTaskSyncImportResult {

    messages: string[];
    originalFilename: string;
    sourceTaskId: number;
    status: string;
    targetTaskId: number;

    constructor();
    constructor( jsonObj: any );
    constructor( genTaskSyncImportResult: GenTaskSyncImportResult);

    constructor( input?: GenTaskSyncImportResult ) {
        if ( input && typeof input !== 'number' ) {
            this.messages = input.messages; // list [string]
            this.originalFilename = input.originalFilename; // string [string]
            this.sourceTaskId = input.sourceTaskId; // int [number]
            this.status = input.status; // string [string]
            this.targetTaskId = input.targetTaskId; // int [number]
       }
    }

    static jsonResponseToList(arr: any[]): GenTaskSyncImportResult[] {
        if (arr && arr.map) {
          return arr.map(a => new GenTaskSyncImportResult(a));
        } else {
          return [];
        }
    }
}

